import * as React from 'react';

import { PhoneButton } from '../../components/PhoneButton';
import { useCall } from '../../hooks/useCall';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { useSelector } from 'react-redux';

interface IProps {
  offerId: number;
  onClick?(): void;
}

export const PhoneButtonContainer: React.VFC<IProps> = ({ offerId, onClick }) => {
  const offer = useSelector(selectRecommendationById(offerId));

  const [showCalltrackingWarning, setShowCalltrackingWarning] = React.useState<boolean>(false);

  const {
    phone,
    handleCall,
    trackPhoneClick,
    trackCloseCallTracking,
    trackAcceptCallTracking,
    trackShowCallTrackingWarning,
    isLeadFactory,
    isCalltrackingEnabled,
  } = useCall(offer, onClick);

  const closeWarning = () => {
    setShowCalltrackingWarning(false);
    trackCloseCallTracking();
  };

  const openWarning = () => {
    setShowCalltrackingWarning(true);
    trackPhoneClick();
    trackShowCallTrackingWarning();
  };

  const clickHandlerWithWarning = React.useCallback(() => {
    handleCall();
    setShowCalltrackingWarning(false);
    trackAcceptCallTracking();
  }, [handleCall, trackAcceptCallTracking]);

  if (!phone) {
    return null;
  }

  return (
    <PhoneButton
      isCalltrackingEnabled={isCalltrackingEnabled}
      text={isLeadFactory ? 'Показать контакты' : undefined}
      clickHandler={handleCall}
      clickHandlerWithWarning={clickHandlerWithWarning}
      openWarning={openWarning}
      closeWarning={closeWarning}
      showCalltrackingWarning={showCalltrackingWarning}
    />
  );
};
